import { toast } from 'react-toastify';

export default {
  ValidateFormProfile(form) {
    if(!form.firstname) {
      toast.warning("First Name is empty!")
      return false

    } else if(!form.lastname) {
      toast.warning("Last Name is empty!")
      return false
    }
    return true
  },
  ValidateFormPassword(form) {
    if(!form.oldpassword) {
      toast.warning("Old Password is empty!")
      return false

    } else if(!form.newpassword) {
      toast.warning("New Password is empty!")
      return false
    }
    return true
  }
}


// WEBPACK FOOTER //
// ./src/App/superuser/user/form.js